import React from 'react';
import type { RouteComponentProps } from '@reach/router';
import MetaTags from 'react-meta-tags';
import ContentContainerDefault from '~/components/ContentContainer/Default';
import MasterDetail from '~/components/MasterDetail';
import TEST_ID_MASTER_DETAIL from '~/components/MasterDetail/index.testid';
import Connections from './components/Connections';
import Synchronization from './components/Synchronization';
import { useGetAppStatusRealworksQuery } from '~/graphql/types';
import useCurrentAccount from '~/hooks/useCurrentAccount';
import NotFound from '~/components/404';
import Toolbar from '~/components/Toolbar';
import JustificationContainer from '~/components/JustificationContainer';
import { Body } from '~/components/Typography/index';
import StatusIndicator from '~/components/StatusIndicator';
import TEST_ID from './index.testid';
import useApp from '~/hooks/useApp';

type Props = RouteComponentProps & {};

// const AGREED_POLLING_INTERVAL = 2000;

const Realworks: React.FC<Props> = ({ uri = '' }) => {
  const { id: accountId } = useCurrentAccount();
  const { data, loading, refetch, updateQuery } = useGetAppStatusRealworksQuery(
    {
      variables: {
        accountId,
      },
    },
  );

  const { app } = useApp('AppStatus_Realworks');
  if (loading) return null;
  if (!data || !app?.appStatus.enabled) return <NotFound />;

  const isSyncActive = data.getAppStatusRealworks.relatieSync.enabled;

  return (
    <>
      <MetaTags>
        <title>Realworks</title>
      </MetaTags>
      <ContentContainerDefault
        breadcrumbs={[
          {
            to: '/-/apps',
            label: 'Apps',
          },
          { label: 'Realworks' },
        ]}
      >
        <JustificationContainer
          justification="center"
          align="center"
          margin={[null, null, 'l', null]}
        >
          <Toolbar>
            <div />
            <JustificationContainer
              justification="end"
              align="center"
              margin={['base']}
            >
              <Body withoutMargin dataTestId={TEST_ID.SYNC_STATUS}>
                {isSyncActive
                  ? 'Synchronisatie actief'
                  : 'Synchronisatie nog niet actief'}
              </Body>
              &nbsp; &nbsp;
              <StatusIndicator status={isSyncActive ? 'active' : 'inactive'} />
            </JustificationContainer>
          </Toolbar>
        </JustificationContainer>
        <MasterDetail
          basePath={uri}
          dataTestId={TEST_ID_MASTER_DETAIL.CONTAINER}
          navbar={[
            {
              type: 'link',
              to: '',
              icon: 'link',
              name: 'Koppelingen',
            },
            {
              type: 'link',
              to: '/synchronization',
              icon: 'reload',
              name: 'Synchronisatie',
            },
          ]}
        >
          <Connections
            path="/*"
            appStatus={data.getAppStatusRealworks}
            refreshAppStatus={refetch}
          />
          <Synchronization
            path="/synchronization"
            appStatus={data.getAppStatusRealworks}
            updateQuery={updateQuery}
          />
        </MasterDetail>
      </ContentContainerDefault>
    </>
  );
};

export default Realworks;
